// Social Media Links
export const SOCIAL_LINKS = {
  LINKEDIN: "https://www.linkedin.com/in/aviralkumarsrivastava/",
  EMAIL: "mailto:aviral23.1999@gmail.com",
  INSTAGRAM: "https://www.instagram.com/aviral_muriel_bing",
  GITHUB: "https://github.com/aviraw",
  TWITTER: "https://x.com/Aviraw237"
};

// Form Configuration
export const FORMSPREE_ENDPOINT = "https://formspree.io/f/xdknkkkg";

// Navigation Items
export const NAV_ITEMS = [
  { label: "Home", href: "#home" },
  { label: "Experience", href: "#experience" },
  { label: "Research", href: "#research" },
  { label: "Projects", href: "#projects" },
  { label: "Skills", href: "#skills" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" }
];
